<template>
    <div>
        <WalletList :item="wallet"/>
    </div>
</template>

<script>

import WalletList from '../WalletList.vue'
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'main-wallet-list',
    components: { WalletList },
    computed: {
        cards () { return this.$store.getters.cards },
        wallets () { return this.$store.getters.wallets }
    },
    data () {
        return {
            wallet: false
        }
    },
    mounted () {
        this.getWalletsAndCards();

        var wallet_id = this.$route.params.wallet_id;
        if ( wallet_id ) {
            this.wallet = this.wallets.find(w => w._id == wallet_id);
            console.log('wallet',wallet);
        }
        
    },
    methods: {
        ...mapActions([
            'getWalletsAndCards'
        ]),
    }
}

</script>

<style>

</style>